import { ClientModels } from "./client";

export class Contact {
  public contactId: number;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public emailAddress: string;
  public address: string;
  public city: string;
  public state: string;
  public country: string;
  public countryCode: string;
  public cellPhoneNo: string;
  public phone: string;
  public phoneExt: string;
  public clientId: number | null;
  public contactStatusId?: number;
  public clientLocationId?: number;
  public secondaryEmailAddress?: string[];
  public jobTitle?: string;
  public departmentName?: string;
  public timeZone?: string;
  public newTagIds: number[];
  public deletedTagIds: number[];
  public description?: string;
  public serviceProviderId?: number;
  public isBillingContact?: boolean;
  /** End-user remote access: 0 off, 1 own devices + open-ticket devices, 2 every device of the client. */
  public remoteAccessLevel?: number;

  constructor(
    contactId: number,
    firstName: string,
    middleName: string,
    lastName: string,
    emailAddress: string,
    address: string,
    city: string,
    state: string,
    country: string,
    countryCode: string,
    cellPhoneNo: string,
    phone: string,
    phoneExt: string,
    clientId: number | null,
    contactStatusId?: number,
    clientLocationId?: number,
    secondaryEmailAddress?: string[],
    jobTitle?: string,
    departmentName?: string,
    timeZone?: string,
    description?: string,
    serviceProviderId?: number,
    isBillingContact?: boolean,
  ) {
    this.contactId = contactId;
    this.firstName = firstName;
    this.middleName = middleName;
    this.lastName = lastName;
    this.emailAddress = emailAddress;
    this.address = address;
    this.city = city;
    this.state = state;
    this.country = country;
    this.countryCode = countryCode;
    this.cellPhoneNo = cellPhoneNo;
    this.phone = phone;
    this.phoneExt = phoneExt;
    this.clientId = clientId;
    this.contactStatusId = contactStatusId;
    this.clientLocationId = clientLocationId;
    this.secondaryEmailAddress = secondaryEmailAddress;
    this.jobTitle = jobTitle;
    this.departmentName = departmentName;
    this.timeZone = timeZone;
    this.description = description;
    this.serviceProviderId = serviceProviderId;
    this.isBillingContact = isBillingContact;
    this.newTagIds = [];
    this.deletedTagIds = [];
  }
}

export interface IContact {
  contactId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  fullName: string;
  emailAddress: string;
  address: string;
  city: string;
  state: string;
  country: string;
  cellPhoneNo: string;
  phone: string;
  phoneExt: string;
  clientId: number;
  contactStatusId?: number;
  clientLocationId?: number;
  isActive: boolean;
  createdOn: Date;
  createdById: number;
  updatedOn: Date;
  updatedById: number;
  secondaryEmailAddress?: string[];
  jobTitle: string;
  departmentName: string;
  client: ClientModels.IClient;
  status: string;
  designationIds?: number[];
}

export class ContactState {
  public declare Contact: Contact;
  public declare IsInitialized: boolean;
  public declare EmailConfigurationId: number | null;
  public declare ClientGroupIds: number[] | null;
  public declare isBillingContact: boolean;
  public declare hasAllTicketsTag: boolean;
  public declare hasAllInvoicesTag: boolean;
  public declare hasAllAssetsTag: boolean;
}

export namespace ContactModels {
  export class ContactDesignation {
    public constructor(
      public contactDesignationId: number,
      public contactDesignationName: string,
      public serviceProviderId: number,
    ) {}
  }

  export class ContactTagAddRequestModel {
    public name: string;
    public description: string;
    public isApprover: boolean | null;
  }

  export class ContactTagModel {
    public tagId: number;
    public name: string;
    public description: string;
    public isApprover: boolean;
  }

  export class ContactTagMappingsRequestModel {
    public tagId: number;
    public newTagIds: number[];
    public deletedTagIds: number[];
  }
}
